/**
 * FREE GIFTS on ₹999+ Manager
 * Handles cart monitoring, gift claiming, and banner updates
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    threshold: 999, // Minimum cart amount in rupees
    giftProducts: {
      // These are placeholder handles - user will create actual products
      photoFrame: 'free-photo-frame-gift',
      keychain: 'free-personalized-keychain-gift',
      ring: 'free-custom-name-ring-gift'
    },
    storageKeys: {
      wonGifts: 'wonFreeGifts999',
      giftsClaimed: 'giftsClaimed999',
      customerName: 'freeGiftName999',
      expiry: 'freeGiftsExpiry'
    }
  };

  // State
  let currentCartTotal = 0;
  let hasGiftsInCart = false;

  /**
   * Initialize the free gift manager
   */
  function init() {
    console.log('Free Gift Manager: Initializing...');

    // Check if user has won the free gifts offer
    if (!checkIfWonGifts()) {
      console.log('Free Gift Manager: User has not won free gifts yet');
      return;
    }

    // Get current cart state
    fetchCart().then(cart => {
      if (cart) {
        updateState(cart);
        updateBanner();
        updateProgressSection();
      }
    });

    // Listen for cart updates
    document.addEventListener('cart:updated', handleCartUpdate);

    console.log('Free Gift Manager: Initialized successfully');
  }

  /**
   * Check if user has won the free gifts offer
   */
  function checkIfWonGifts() {
    const wonGifts = localStorage.getItem(CONFIG.storageKeys.wonGifts);
    const expiry = localStorage.getItem(CONFIG.storageKeys.expiry);

    if (!wonGifts) {
      return false;
    }

    // Check if expired (7 days)
    if (expiry && Date.now() > parseInt(expiry)) {
      clearGiftData();
      return false;
    }

    return true;
  }

  /**
   * Fetch current cart data
   */
  async function fetchCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart;
    } catch (error) {
      console.error('Free Gift Manager: Error fetching cart', error);
      return null;
    }
  }

  /**
   * Update internal state based on cart
   */
  function updateState(cart) {
    // Calculate cart total (in rupees, convert from cents)
    currentCartTotal = cart.total_price / 100;

    // Check if free gifts are in cart
    hasGiftsInCart = cart.items.some(item => {
      return item.product_type === 'FREEGIFT999' ||
             item.handle.includes('free-') && item.handle.includes('-gift');
    });

    console.log('Free Gift Manager: Cart total =', currentCartTotal, ', Has gifts =', hasGiftsInCart);
  }

  /**
   * Handle cart update event
   */
  function handleCartUpdate(event) {
    const cart = event.detail;
    if (cart) {
      updateState(cart);
      updateBanner();
      updateProgressSection();

      // Check thresholds
      if (currentCartTotal >= CONFIG.threshold && !hasGiftsInCart) {
        showClaimPopup();
      } else if (currentCartTotal < CONFIG.threshold && hasGiftsInCart) {
        showWarningPopup();
      }
    }
  }

  /**
   * Update the sticky banner
   */
  function updateBanner() {
    const banner = document.getElementById('freeGiftBanner');
    if (!banner) return;

    const bannerText = document.getElementById('freeGiftBannerText');
    const bannerCTA = document.getElementById('freeGiftBannerCTA');

    if (currentCartTotal >= CONFIG.threshold) {
      // Threshold reached
      banner.style.background = 'linear-gradient(135deg, #3c9343 0%, #2d7a34 100%)';
      if (bannerText) {
        if (hasGiftsInCart) {
          bannerText.innerHTML = '✅ <strong>FREE GIFTS CLAIMED!</strong> Check your cart';
        } else {
          bannerText.innerHTML = '🎊 <strong>FREE GIFTS UNLOCKED!</strong> Claim your gifts in cart';
        }
      }
      if (bannerCTA) {
        bannerCTA.textContent = 'GO TO CART';
        bannerCTA.href = '/cart';
      }
    } else {
      // Below threshold
      const remaining = CONFIG.threshold - currentCartTotal;
      banner.style.background = 'linear-gradient(135deg, #242526 0%, #3a3b3c 100%)';
      if (bannerText) {
        bannerText.innerHTML = `🎁 Add <strong>₹${Math.ceil(remaining)}</strong> more to unlock FREE Gifts!`;
      }
      if (bannerCTA) {
        bannerCTA.textContent = 'SHOP NOW';
        bannerCTA.href = '/collections/all';
      }
    }

    // Show banner
    banner.style.display = 'flex';
  }

  /**
   * Update progress section on cart page
   */
  function updateProgressSection() {
    const progressContainer = document.getElementById('freeGiftProgressContainer');
    if (!progressContainer) return; // Not on cart page

    const progressBar = document.getElementById('freeGiftProgressBar');
    const progressPercent = document.getElementById('freeGiftProgressPercent');
    const currentAmount = document.getElementById('freeGiftCurrentAmount');
    const remainingAmount = document.getElementById('freeGiftRemainingAmount');
    const claimSection = document.getElementById('freeGiftClaimSection');
    const needMoreSection = document.getElementById('freeGiftNeedMoreSection');

    // Calculate percentage
    const percentage = Math.min((currentCartTotal / CONFIG.threshold) * 100, 100);

    // Update progress bar
    if (progressBar) {
      progressBar.style.width = percentage + '%';
    }
    if (progressPercent) {
      progressPercent.textContent = Math.round(percentage) + '%';
    }
    if (currentAmount) {
      currentAmount.textContent = '₹' + Math.round(currentCartTotal);
    }

    if (currentCartTotal >= CONFIG.threshold) {
      // Show claim section
      if (needMoreSection) needMoreSection.style.display = 'none';
      if (claimSection) claimSection.style.display = 'block';

      // If already claimed, show success message
      if (hasGiftsInCart) {
        const claimForm = document.getElementById('freeGiftClaimForm');
        if (claimForm) claimForm.style.display = 'none';

        const successMessage = document.getElementById('freeGiftSuccessMessage');
        if (successMessage) successMessage.style.display = 'block';
      }
    } else {
      // Show need more section
      const remaining = CONFIG.threshold - currentCartTotal;
      if (remainingAmount) {
        remainingAmount.textContent = '₹' + Math.ceil(remaining);
      }

      if (needMoreSection) needMoreSection.style.display = 'block';
      if (claimSection) claimSection.style.display = 'none';
    }
  }

  /**
   * Show claim popup (when threshold reached)
   */
  function showClaimPopup() {
    // For MVP, we'll show this in the cart page itself
    // Full popup can be added later
    console.log('Free Gift Manager: Show claim popup');
  }

  /**
   * Show warning popup (when cart drops below threshold with gifts)
   */
  function showWarningPopup() {
    const warning = document.getElementById('freeGiftWarning');
    if (!warning) return;

    warning.classList.add('active');
  }

  /**
   * Claim the free gifts
   */
  async function claimGifts(customerName) {
    if (!customerName || customerName.trim() === '') {
      alert('Please enter your name for personalization');
      return false;
    }

    // Validate name length (max 20 characters for MVP)
    if (customerName.length > 20) {
      alert('Name must be 20 characters or less');
      return false;
    }

    console.log('Free Gift Manager: Claiming gifts for', customerName);

    // Store customer name
    localStorage.setItem(CONFIG.storageKeys.customerName, customerName);
    localStorage.setItem(CONFIG.storageKeys.giftsClaimed, 'true');

    // Add gifts to cart
    // NOTE: These are placeholder product handles
    // User needs to create actual products in Shopify
    const giftsToAdd = [
      {
        id: CONFIG.giftProducts.photoFrame,
        quantity: 1,
        properties: {}
      },
      {
        id: CONFIG.giftProducts.keychain,
        quantity: 1,
        properties: {
          'Name': customerName
        }
      },
      {
        id: CONFIG.giftProducts.ring,
        quantity: 1,
        properties: {
          'Name': customerName
        }
      }
    ];

    // For MVP, we'll show a message that products need to be created
    console.log('Would add these items to cart:', giftsToAdd);

    // Show success message
    alert(`🎉 Success! Your free gifts will be added once you create the products in Shopify.\n\nGifts for: ${customerName}\n- Photo Frame\n- Personalized Keychain\n- Custom Name Ring`);

    // Mark as claimed
    hasGiftsInCart = true;
    updateBanner();
    updateProgressSection();

    return true;
  }

  /**
   * Remove all free gifts from cart
   */
  async function removeAllGifts() {
    console.log('Free Gift Manager: Removing all gifts');

    // Clear storage
    localStorage.removeItem(CONFIG.storageKeys.giftsClaimed);
    localStorage.removeItem(CONFIG.storageKeys.customerName);

    // Fetch cart and remove gift items
    const cart = await fetchCart();
    if (!cart) return;

    const giftItems = cart.items.filter(item => {
      return item.product_type === 'FREEGIFT999' ||
             item.handle.includes('free-') && item.handle.includes('-gift');
    });

    // Remove each gift item
    for (const item of giftItems) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: item.key,
          quantity: 0
        })
      });
    }

    // Update state
    hasGiftsInCart = false;
    updateBanner();
    updateProgressSection();

    // Reload cart page
    if (window.location.pathname.includes('/cart')) {
      window.location.reload();
    }
  }

  /**
   * Clear all gift-related data
   */
  function clearGiftData() {
    localStorage.removeItem(CONFIG.storageKeys.wonGifts);
    localStorage.removeItem(CONFIG.storageKeys.giftsClaimed);
    localStorage.removeItem(CONFIG.storageKeys.customerName);
    localStorage.removeItem(CONFIG.storageKeys.expiry);
  }

  /**
   * Handle claim form submission
   */
  function handleClaimFormSubmit(event) {
    event.preventDefault();

    const nameInput = document.getElementById('freeGiftNameInput');
    if (!nameInput) return;

    const customerName = nameInput.value.trim();
    claimGifts(customerName);
  }

  /**
   * Handle warning popup buttons
   */
  function handleWarningKeep() {
    // Close warning
    const warning = document.getElementById('freeGiftWarning');
    if (warning) {
      warning.classList.remove('active');
    }
  }

  function handleWarningRemove() {
    removeAllGifts();

    // Close warning
    const warning = document.getElementById('freeGiftWarning');
    if (warning) {
      warning.classList.remove('active');
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose functions globally for onclick handlers
  window.freeGiftManager = {
    claimGifts,
    removeAllGifts,
    handleClaimFormSubmit,
    handleWarningKeep,
    handleWarningRemove,
    updateBanner
  };

})();
